import {createLogger} from '../../common/logging.config';
const logger = createLogger('homepage-util');

module.exports = [ 'shellDataHomepageService', 'shellUtil', function(shellDataHomepageService, shellUtil) {

	
	let userPrefsPubAtGlancePromise = null;
	
	const getPublishingAtAGlancePreferences = () => {
		/*
		 * Returns the JSON promise with only the user preferences for Publishing at a Glance component 
		 */
		if (!userPrefsPubAtGlancePromise) {
			let p1 = new Promise((resolve, reject) => {
				shellDataHomepageService.getUserPreferences().then(
					(data) => {
						if (data.items && data.items.length > 0) {
							data.items.forEach((item) => {
								if (item.widgetPreferences) {
									item.widgetPreferences.forEach((value) => {
										if (value.wcomponent === 'publishing-at-a-glance') {
											let userPreferences = value.preferences;
											logger.info("read user preferences: " + JSON.stringify(userPreferences));
											userPrefsPubAtGlancePromise = p1;
											resolve (userPreferences);
										}
									});
								}
								// possibly old tenant that doesn't have widgetPrefs
								else {
									logger.info("No widget preferences stored for this user");
									resolve({});
								}
							});
						}
						// doesn't look like there is any whats new data for this user at all
						else {
							logger.info("No data or widget preferences stored for this user");
							resolve({});
						}
					},
					(error) => {
						logger.error('Error retrieving current user preference data from server: ' + error);
						userPrefsPubAtGlancePromise = null;
						reject (error);
					}
				);
			});

			return p1;
			
		}
		else {
			return userPrefsPubAtGlancePromise;
		}
	}
	
	const setPublishingAtAGlancePreferences = (newPrefs) => {
		return new Promise((resolve, reject) => {
			let update = null;
			if (newPrefs) {
				userPrefsPubAtGlancePromise = null;
					
				// get all of the current user prefs and update the values for publishing at a glance
				shellDataHomepageService.getUserPreferences().then(data => {
					if (data.items && data.items.length > 0) {
						data.items.forEach((item) => {
							if (item.widgetPreferences) {
								item.widgetPreferences.forEach((value) => {
									if (value.wcomponent === 'publishing-at-a-glance') {
										value.preferences = newPrefs;
										logger.info("set user preferences: " + JSON.stringify(item.widgetPreferences));
										update = item.widgetPreferences;
									}
								});
							}
							// possibly old tenant that does not have setting so store new user prefs
							else {
								logger.info("no current widget prefs, will set user preferences to: " + JSON.stringify(newPrefs));
								update = [{wcomponent:'publishing-at-a-glance', preferences:newPrefs}];
							}
						});
					}
					// doesn't look like there is any whats new data for this user at all
					else {
						logger.info("no data or current widget prefs, will set user preferences to: " + JSON.stringify(newPrefs));
						update = [{wcomponent:'publishing-at-a-glance', preferences:newPrefs}];
					}

					return update;
				}).then(newUserPrefs => {
					if (newUserPrefs !== null) {
						shellDataHomepageService.setUserPreferences({'widgetPreferences':newUserPrefs}).then(rv => {
							resolve (rv);
						});
					}
					// something went terribly wrong above if we are here
					else {
						logger.error("Error setting user preferences");
						reject (false);
					}
				});
			}
			else {
				reject (false);
			}
		});
	}
	
	
	const getCurrentLocale = () => {
		return shellUtil.getCurrentLocale();
	}

	
	const getKeyCode = (event) => {
		// make sure this is a keyboard event, if not return undefined
		let key = event.keyCode;
		if (typeof key !== 'undefined') {
			// some browsers (ex. FF Quantum) put the real keycode in which property 
			key = event.which || event.keyCode || 0;
		}
		return key;
	}
	

 	// return public API for the util factory
	return {
		getPublishingAtAGlancePreferences: getPublishingAtAGlancePreferences,
		setPublishingAtAGlancePreferences: setPublishingAtAGlancePreferences,
		getCurrentLocale: getCurrentLocale,
		getKeyCode: getKeyCode
	};
}];



// WEBPACK FOOTER //
// ./app/common/services/homepage-util.factory.js